var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.external)?_c('router-link',{staticClass:"brand-logo",class:{'vertical-align' : _vm.vertical},attrs:{"to":{path: _vm.path}}}):_vm._e(),(_vm.external)?_c('a',{staticClass:"brand-logo",attrs:{"href":_vm.path,"target":"_blank"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }